module.exports = __webpack_public_path__ + "img/1376385112.08638424.jpg";